const getRegraQualidadeFilterFields = (drops = {}, defaults = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  {
    name: 'produto',
    label: 'Produto',
    type: 'virtual-select',
    options: drops?.Produto,
    multiple: true,
    defaultValue: defaults?.produtoId ? [defaults.produtoId] : [],
    disabled: Boolean(defaults?.produtoId),
  },
  {
    name: 'processo',
    label: 'Processo',
    type: 'select',
    options: drops?.Processo,
    multiple: true,
    defaultValue: defaults?.processoId ? [defaults.processoId] : [],
    disabled: Boolean(defaults?.processoId),
  },
  {
    name: 'natureza_operacao',
    label: 'Natureza da Operação',
    type: 'select',
    options: drops?.NaturezaOperacao,
    multiple: true,
  },
  {
    name: 'qualidade_indicador_id',
    column: 'qualidade_indicador',
    label: 'Indicador de Qualidade',
    type: 'select',
    options: drops?.QualidadeIndicador,
    multiple: true,
  },
];

export default getRegraQualidadeFilterFields;
